<template>
    <div class="ComponentEdit"
        :style="{ transform: 'scale(' + innerWidth / canvasConfig.width + ',' + innerHeight / canvasConfig.height + ')', 'background-image': canvasConfig.backgroundImage ? `url(${commenUrl + canvasConfig.backgroundImage})` : '', 'background-color': canvasConfig.background ? canvasConfig.background : '' }">
        <div class="content1">
            <ComponentEdit :index="0"></ComponentEdit>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance, watch } from 'vue'
import ComponentEdit from "../../components/ChartComponent/ComponentBase/ComponentEdit";
const canvasConfig = ref(computed(() => store.state.chartData.canvasConfig));
import { useStore } from 'vuex';
const store = useStore();
const { proxy } = getCurrentInstance();
// 获取浏览器可视区域宽高
const innerWidth = ref(window.innerWidth)
const innerHeight = ref(window.innerHeight)
console.log(innerWidth, innerHeight, '可视区域尺寸', window)
// innerWidth/chartDatas.canvasConfig.width,innerHeight/chartDatas.canvasConfig.height
const handleResize = () => {
    console.log('尺寸变化')
    innerWidth.value = window.innerWidth
    innerHeight.value = window.innerHeight
}

// 添加事件监听器
window.addEventListener('resize', handleResize);

// 初始化获取数据

const project = ref(computed(() => store.state.project));
const setProjectId = (id) => {
    project.value.id = id
    store.commit("setProject", project.value);
}
const dataFind = (i) => {

    proxy
        .$request({
            url: "BIGDATA_BASIC_PRICE_CONFIG_FIND_DETAIL",
            method: "post",
            data: {
                "path": "test/one"
            },
        })
        .then((res) => {
            if (res.data.code == "000") {
                setProjectId(res.data.result.id)
                store.commit("setChartData", JSON.parse(res.data.result.contents));
            }
        })
        .catch((err) => {
            console.log(err);
        });
}
dataFind()
</script>

<style lang="less" scoped>
/* Add global styles here */
.ComponentEdit {
    width: 1920px;
    height: 1080px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .content1 {
        width: 300px;
        height: 400px;
    }
}
</style>